import './assets/css/styles.css'

import Vue from 'vue'
import axios from 'axios';
import App from './App.vue'
import router from './plugins/router'
import store from './stores/store'
import vuetify from './plugins/vuetify'
import AuthPlugin from './plugin'
import getAuthentication from './utils/authentication'
import VueMoment from 'vue-moment';


let apiHostname = process.env.VUE_APP_API_DOMAIN;
let baseUrl = process.env.VUE_APP_BASE_URL;

axios.defaults.baseURL = baseUrl + apiHostname + 'apiDeposant';

Vue.config.productionTip = false

Vue.use(AuthPlugin, {
  auth: getAuthentication()
})


Vue.filter('toFixed', function (value, precision) {
  if (parseFloat(value) === 0) {
    return 0;
  }
  if (!value) {
    return '';
  }
  if (value === null || value === '') {
    return '';
  }
  value = parseFloat(value).toFixed(precision);
  return value;
})

Vue.use(VueMoment);

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (!this.$auth.isConnected()) {
      next({
        path: '/',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } else {
    next() // make sure to always call next()!
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
